import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangeHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
    } else {
      const heading = document.querySelector('h1');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    }
  }, [location.pathname]);

  return null;
};

export default RouteChangeHandler;
